export default "__VITE_ASSET__DUvHj3FS__"